import { IAddRequestOptions } from "src/app/interface/add-request-options.interface";

const popularChoice = {
  title: "Popular Choice",
  items: [
    {
      label: 'Bookings',
      icon: 'assets/icons/fill-icons/bookings.svg'
    },
    {
      label: 'Prime',
      icon: 'assets/icons/fill-icons/prime.svg'
    },
    {
      label: 'To-Do Tasks',
      icon: 'assets/icons/fill-icons/todo-task.png'
    },
    {
      label: 'Collab',
      icon: 'assets/icons/fill-icons/collab-profile.svg'
    },
    {
      label: 'Meetup',
      icon: 'assets/icons/fill-icons/meetup.svg'
    },
    {
      label: 'Add Reminders',
      icon: 'assets/icons/fill-icons/reminders.svg'
    },
    {
      label: 'Add Transaction',
      icon: 'assets/icons/fill-icons/transaction.svg'
    },
    {
      label: 'Add Contacts',
      icon: 'assets/icons/fill-icons/contacts.svg'
    }
  ]
}

const offSiteServices = {
  title: "Off-Site Services",
  items: [
    {
      label: 'Laundry',
      icon: 'assets/icons/fill-icons/laundry.svg'
    },
    {
      label: 'Pet Care',
      icon: 'assets/icons/fill-icons/petcare.svg'
    },
    {
      label: 'Cleaning',
      icon: 'assets/icons/fill-icons/cleaning.svg'
    },
    {
      label: 'Handyman & Moving',
      icon: 'assets/icons/fill-icons/handyman.svg'
    },
    {
      label: 'Health & Beauty',
      icon: 'assets/icons/fill-icons/beauty.svg'
    },
    {
      label: 'Healthcare & Homeaide',
      icon: 'assets/icons/fill-icons/healthcare.svg'
    },
    {
      label: 'Photo & Video',
      icon: 'assets/icons/fill-icons/photo.svg'
    },
    {
      label: 'Event & Catering',
      icon: 'assets/icons/fill-icons/catering.svg'
    },
    {
      label: 'Tutoring',
      icon: 'assets/icons/fill-icons/tutoring.svg'
    },
    {
      label: 'Personal',
      icon: 'assets/icons/fill-icons/personal.svg'
    },
    {
      label: 'Freelance Work',
      icon: 'assets/icons/fill-icons/freelancer.svg'
    },
    {
      label: 'Automotive Work',
      icon: 'assets/icons/fill-icons/automotive.svg'
    },
    {
      label: 'Home Improvement',
      icon: 'assets/icons/fill-icons/home-improvement.svg'
    },
    {
      label: 'Business Service',
      icon: 'assets/icons/fill-icons/business-service.svg'
    },
    {
      label: 'Legal Service',
      icon: 'assets/icons/fill-icons/legal.svg'
    },
    {
      label: 'Yard Service',
      icon: 'assets/icons/fill-icons/yard.svg'
    }
  ]
}

const inBuildingService = {
  title: "In Building Services",
  items: [
    {
      label: 'Pay Rent',
      icon: 'assets/icons/fill-icons/payrent.svg'
    },
    {
      label: 'Guest Entry',
      icon: 'assets/icons/fill-icons/guest-entry.svg'
    },
    {
      label: 'Front Desk',
      icon: 'assets/icons/fill-icons/frontdesk.svg'
    },
    {
      label: 'Valet Service',
      icon: 'assets/icons/fill-icons/valet.svg'
    },
    {
      label: 'Maintenance Request',
      icon: 'assets/icons/fill-icons/maintenance.svg'
    },
    {
      label: 'Schedule Amenities',
      icon: 'assets/icons/fill-icons/amenities.svg'
    },
    {
      label: 'Package & Delivery',
      icon: 'assets/icons/fill-icons/delivery.svg'
    }
  ]
}
const addListings = {
  title: "Add Listings",
  items: [
    {
      label: 'Services',
      icon: 'assets/icons/fill-icons/services.svg'
    },
    {
      label: 'Jobs',
      icon: 'assets/icons/fill-icons/jobs.svg'
    },
    {
      label: 'Buy, Sell & Rent',
      icon: 'assets/icons/fill-icons/rentals.svg'
    },
    {
      label: 'Items',
      icon: 'assets/icons/fill-icons/items.svg'
    },
    {
      label: 'Topic',
      icon: 'assets/icons/fill-icons/topic.svg'
    },
    {
      label: 'Events',
      icon: 'assets/icons/fill-icons/events.png'
    },
    {
      label: 'Recommend',
      icon: 'assets/icons/fill-icons/recommendations.svg'
    },
    {
      label: 'Announce',
      icon: 'assets/icons/fill-icons/announcement.png'
    }
  ]
}
export const requestOptions: IAddRequestOptions[] = [
  popularChoice, offSiteServices, inBuildingService, addListings
]